import { useFlags } from 'launchdarkly-react-client-sdk';

interface RenderFeatureIfTrueProps {
  children: React.ReactNode | React.ReactNodeArray;
  flag: string;
  fallback?: JSX.Element;
}

export const RenderFeatureIfTrue = ({
  children,
  flag,
  fallback,
}: RenderFeatureIfTrueProps) => {
  const flags = useFlags();

  if (flags[flag]) {
    return <>{children}</>;
  }

  return fallback || <></>;
};
